import { ToastrService } from 'ngx-toastr';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { LicensingService } from './../../../../services/seed/licensing.service';
import { AddUpdateLicenseSliderModelService } from './add-update-license-slider-model.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-add-update-license',
  templateUrl: './add-update-license.component.html',
  styleUrls: ['./add-update-license.component.scss']
})

export class AddUpdateLicenseComponent implements OnInit, OnDestroy {
  private subscription = new Array<Subscription>();

  licenseDataSource: any;
  licenseList: any;
  displayedColumns: string[] = ['licenseStatus', 'manufacturer', 'licenseNumber'];
  grower: any;
  requireddata: any;
  licensedata: any = [];
  growerGLN: any;
  saveLicense = false;

  constructor(
    public broadcastService: BroadcastService,
    public configService: ConfigService,
    private toastrService: ToastrService,
    private addUpdateLicenseSliderModelService: AddUpdateLicenseSliderModelService,
    private loaderService: LoaderService,
    private licensingService: LicensingService) {
  }
  // ngOnInit
  ngOnInit() {
    this.grower = this.licensingService.getLicenseInfoData().grower;
    this.requireddata = this.licensingService.getLicenseInfoData().required;
    this.licenseList = this.licensingService.getLicenseInfoData().licenseList;
    this.licenseDataSource = new MatTableDataSource(this.licenseList);
    this.getGrowerGLN(this.grower.gmk);
  }

  getGrowerGLN(gmk) {
    this.subscription.push(this.licensingService.getGrowerGLN(gmk).subscribe(result => {
      this.growerGLN = result;
    }, error => {
    }));
  }

  // Selected product will add on order
  saveLicenseInfo() {
    this.licensedata = [];
    for (const index in this.licenseList) {
      this.licensedata.push({
        LicenseNumber: this.licenseList[index]['licenseNumber'],
        LicenseStatus: this.licenseList[index]['licenseStatus'],
        VendorId: this.licenseList[index]['vendorId'],
        Gmk: this.grower.gmk,
        GrowerLicenseId: this.licenseList[index]['growerLicenseId']
      });
    }
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.licensingService.addUpdateDeleteGrowerLicense(this.licensedata).subscribe(result => {
      if (result && result.length > 0) {      
        if (result.every(v => v === true)) {
          this.toastrService.success('Records saved successfully.');
        }
        else if (result.every(v => v === false)) {
          this.toastrService.error('License is invalid and cannot be saved.');
        }
        else {
          this.toastrService.warning('Records partially processed.');
        }
      }
      else {
        this.toastrService.info('No records to process.');
      }
      this.addUpdateLicenseSliderModelService.licenseClose();
      const data = Object.assign({}, this);
      data.saveLicense = true;
      this.addUpdateLicenseSliderModelService.setData<AddUpdateLicenseComponent>(data);
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.addUpdateLicenseSliderModelService.licenseClose();
    }));
  }

  public ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
